export enum ContentType {
	CKEditor = "CKEditor",
	ImageBanner = "ImageBanner",
	Gallery = "Gallery",
	Benefits = "Benefits",
	ContactButton = "ContactButton",
	Link = "Link",
	Quotation = "Quotation",
	UnorderedList = "UnorderedList",
}
